import script from "./Popover.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Popover.vue?vue&type=script&setup=true&lang=js"
export * from "./Popover.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./Popover.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__